import list_icon from '@/assets/img/device/mer68/Mer68_icon.png'
import { Mer68 } from './mer68'

export class Mer68Pro extends Mer68 {
  name: string = 'Mer68_Pro'
  icon: string = list_icon
  width: number = 672
}
